<template>
  <el-upload
    class="avatar-uploader"
    :action="upload_url"
    :show-file-list="false"
    :on-success="handleSuccess"
    :before-upload="beforeUpload"
    :headers="headers"
  >
    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
import { getToken } from "../../config/cache";

export default {
  name: "upload",
  props: {
    size: {
      type: Number,
      default: 1
    },
    images: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      upload_url: `${this.$config.api_url}admin/image/upload`,
      dialogVisible: false,
      imageUrl: ""
    };
  },
  computed: {
    headers() {
      const token = getToken(); //获取本地token
      return { Authorization: token };
    }
  },

  methods: {
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt500K = file.size / 1024 / 1024 < this.size;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt500K) {
        this.$message.error("上傳圖片大小不能超過1M");
      }
      return isLt500K;
    },
    handleSuccess(response, file, fileList) {
      console.log("result:", response);
      if (response.code == 200) {
        this.imageUrl = response.data.path;
        this.$emit("success", response.data);
      } else {
        this.images = [];
        this.$message.error(response.msg);
      }
    },
    handlePreview(file) {
      this.imageUrl = file.url;
      this.dialogVisible = true;
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    setImage(file) {
      if (file) {
        this.imageUrl = file.url;
        this.images = [file];
      } else {
        this.images = [];
      }
    }
  }
};
</script>

<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
</style>